import { FormikProps, withFormik } from 'formik';
import * as React from 'react';
import { AnalyticsExtensionsSettingsStyles } from '../styles/AnalyticsExtensionsSettingsStyles';

import { CheckBoxWithLabelWidget, DropdownButtonType, List, ListItem,SingleSelectDropdown, TextFieldWidget } from '@tableau/widgets';
import { Messages } from '../../codegen/Localize';
import { IResult } from '../../ts/ServerApi/types/IResponse';
import { ErrorNotifyingServer } from '../../ts/services/ErrorNotifyingServer';
import { AnalyticsExtensionsSettingsCtrlProps } from '../controllers/SiteSettingsForAnalyticsExtensionsCtrl';
import { IAnalyticsExtConnectionSettings, IAnalyticsExtSiteSettings } from '../interfaces/ISiteSettingsForSiteAdmin';


export interface AnalyticsExtensionsSettingsForSiteValues {
  showAnalyticsSiteSetting: boolean;
  showSiteCheckbox: boolean;
  enableExternalServicesCheckbox: boolean;
  connectionLUID: string;
  connectionName: string;
  connectionType: string;
  hostName: string;
  port: number;
  isAuth: boolean;
  userName: string;
  password: string;
  isSecure: boolean;
}

const ConnectionTypes = {
  TABPY: {
    TAG: 'TABPY',
    DISPLAY: 'TabPy/External API'
  },
  RSERVE: {
    TAG: 'RSERVE',
    DISPLAY: 'Rserve'
  },
  SELECT: 'Select'
};


const connectionItems: ListItem[] = [
  {value: ConnectionTypes.SELECT},
  {value: ConnectionTypes.TABPY.DISPLAY},
  {value: ConnectionTypes.RSERVE.DISPLAY}
];

const MAX_HOSTNAME_LENGTH: number = 255;
const MIN_PORT_NUMBER: number = 0;
const MAX_PORT_NUMBER: number = 65535;
const MAX_USERNAME_LENGTH: number = 255;
const MAX_PASSWORD_LENGTH: number = 255;

export type InnerAnalyticsExtensionsSettingForSiteProps =
  AnalyticsExtensionsSettingsCtrlProps & FormikProps<AnalyticsExtensionsSettingsForSiteValues> & AnalyticsExtensionsSettingsForSiteValues;

interface AnalyticsExtensionsSettingsForSiteState{
  isBusy: boolean;
  saveFormState: IResult;
}
export class InnerAnalyticsExtensionsSettingForSite extends React.PureComponent <InnerAnalyticsExtensionsSettingForSiteProps, AnalyticsExtensionsSettingsForSiteState> {
  constructor(props: InnerAnalyticsExtensionsSettingForSiteProps) {
    super(props);
    props.setSaveCallback(()=> this.sendUpdateSave());
    props.setCancelCallback(props.handleReset);
    props.setIsBusy(() => props.isSubmitting);

  }

  public sendUpdateSave(): ng.IPromise<IResult> {
    // need showAnalyticsSiteSetting check because current design require the hack to handle signle/multisite
    // this is how extension team does it, refactoring requires lots of work and would need to refactor their page
    if (this.props.values.showAnalyticsSiteSetting) {
      const updateSiteSettings: IAnalyticsExtSiteSettings = {enabled: this.props.values.enableExternalServicesCheckbox};
      let connection = '';
      if (this.props.values.connectionType === ConnectionTypes.TABPY.DISPLAY) {
        connection = ConnectionTypes.TABPY.TAG;
      } else if (this.props.values.connectionType === ConnectionTypes.RSERVE.DISPLAY) {
        connection = ConnectionTypes.RSERVE.TAG;
      } else { // No connection created. Only save the site enable/disbale setting
        this.props.handleSubmit();
        return this.props.sendUpdateRequest(updateSiteSettings, null);
      }
      const updateConnectionSettings: IAnalyticsExtConnectionSettings = {
        connection_luid: this.props.values.connectionLUID,
        //connectionName: 'default',
        connection_type: connection,
        host: this.props.values.hostName,
        port: this.props.values.port,
        is_ssl_enabled: this.props.values.isSecure,
        is_auth_enabled: this.props.values.isAuth,
        username: this.props.values.userName,
        password: this.props.values.password
      };
      this.props.handleSubmit();
      return this.props.sendUpdateRequest(updateSiteSettings, updateConnectionSettings);
    }
    this.props.handleSubmit();
  }

  public componentDidUpdate() {
    // Let the Angular controller know things have changed
    this.props.setIsFormDirty(this.props.dirty);
    this.props.setIsFormValid(this.props.isValid);
    this.props.setIsBusy(() => this.props.isSubmitting);
  }

  private handleChangeAdapter = (value: any, fieldName: keyof AnalyticsExtensionsSettingsForSiteValues) => {
    const event = {
      target: {
        name: fieldName,
        value
      }
    };
    // Call the Formik handleChange
    this.props.handleChange(event);
  }

  private clearLoginInfo()
  {
    this.handleChangeAdapter('', 'userName');
    this.handleChangeAdapter('', 'password');
  }

  render() {
    return(
      <section>
        <div className={this.props.values.showAnalyticsSiteSetting?AnalyticsExtensionsSettingsStyles.enableForSite : AnalyticsExtensionsSettingsStyles.Hide}>
          <CheckBoxWithLabelWidget
            checked={this.props.values.enableExternalServicesCheckbox}
            handleChange={(isBoxChecked: boolean) => {
              this.handleChangeAdapter(isBoxChecked, 'enableExternalServicesCheckbox');
            }}
            testId="anext_site_enable_checkbox"
            label={Messages.analyticsExtensionsSettingsSite_checkbox()}
            disabled={!this.props.values.showSiteCheckbox}/>
        </div>
        <div>
          <div className={this.props.values.showAnalyticsSiteSetting?AnalyticsExtensionsSettingsStyles.connectionSettingsTable:AnalyticsExtensionsSettingsStyles.Hide}>
            <div className={AnalyticsExtensionsSettingsStyles.connectionSettingsRow}>
              <div className={AnalyticsExtensionsSettingsStyles.connectionSettingsCell}>
                <SingleSelectDropdown
                  testId="anext_site_connection_dropdown"
                  label={Messages.analyticsExtensionsSettingsConnectoinType()}
                  list={<List items={connectionItems} selectedValue={this.props.values.connectionType}/>}
                  onChange={(connectionType: string) => {
                    this.handleChangeAdapter(connectionType, 'connectionType');}
                  }
                  onBlur={e => {this.props.handleBlur(e);}}
                  style={{ width: 145 }}
                  type={DropdownButtonType.Line}
                  disabled={false}
                  value={this.props.values.connectionType}
                  valid={this.props.errors.connectionType? false : undefined}
                  />
              </div>
              <div className={AnalyticsExtensionsSettingsStyles.connectionSettingsCell}>
                <TextFieldWidget
                  testId="anext_site_host_textfield"
                  label={Messages.host()}
                  onChange={e => {
                    this.handleChangeAdapter(e.target.value, 'hostName');
                    this.clearLoginInfo();}
                  }
                  onBlur={e => {this.props.handleBlur(e);}}
                  value={this.props.values.hostName}
                  disabled={this.props.values.connectionType === ConnectionTypes.SELECT}
                  valid={this.props.errors.hostName? false : undefined}
                />
              </div>
              <div className={AnalyticsExtensionsSettingsStyles.connectionSettingsCell}>
                <TextFieldWidget
                  testId="anext_site_port_textfield"
                  label={Messages.port()}
                  onChange={e => {
                    this.handleChangeAdapter(e.target.value, 'port');
                    this.clearLoginInfo();}
                  }
                  onBlur={e => {this.props.handleBlur(e);}}
                  value={this.props.values.port}
                  className={AnalyticsExtensionsSettingsStyles.connectionPortInput}
                  disabled={this.props.values.connectionType === ConnectionTypes.SELECT}
                  valid={this.props.errors.port? false : undefined}
                />
              </div>
              <div className={AnalyticsExtensionsSettingsStyles.connectionSettingsCell}>
                <CheckBoxWithLabelWidget
                  checked={this.props.values.isSecure}
                  handleChange={(isBoxChecked: boolean) => {
                    this.handleChangeAdapter(isBoxChecked, 'isSecure');
                    this.clearLoginInfo();
                  }}
                  testId="anext_site_secure_checkbox"
                  label={Messages.ssl()}
                  containerStyle={AnalyticsExtensionsSettingsStyles.connectionSslCheckbox}
                  disabled={this.props.values.connectionType === ConnectionTypes.SELECT}
                  />
              </div>
              <div className={AnalyticsExtensionsSettingsStyles.connectionSettingsCell}>
                <CheckBoxWithLabelWidget
                  checked={this.props.values.isAuth}
                  handleChange={(isBoxChecked: boolean) => {
                    this.handleChangeAdapter(isBoxChecked, 'isAuth');
                    this.clearLoginInfo();}}
                  testId="anext_site_auth_checkbox"
                  label={Messages.authentication()}
                  disabled={this.props.values.connectionType === ConnectionTypes.SELECT}
                  />
              </div>
              <div className={AnalyticsExtensionsSettingsStyles.connectionSettingsCell}>
                <TextFieldWidget
                  testId="anext_site_userName_textfield"
                  label={Messages.username()}
                  onChange={e => {this.handleChangeAdapter(e.target.value, 'userName');}}
                  onBlur={e => {this.props.handleBlur(e);}}
                  value={this.props.values.userName}
                  disabled={(this.props.values.connectionType === ConnectionTypes.SELECT) || (!this.props.values.isAuth)}
                  valid={this.props.errors.userName? false : undefined}
                />
              </div>
              <div className={AnalyticsExtensionsSettingsStyles.connectionSettingsCell}>
                <TextFieldWidget
                  testId="anext_site_password_textfield"
                  label={Messages.password()}
                  onChange={e => {this.handleChangeAdapter(e.target.value, 'password');}}
                  onBlur={e => {this.props.handleBlur(e);}}
                  value={this.props.values.password}
                  disabled={(this.props.values.connectionType === ConnectionTypes.SELECT) || (!this.props.values.isAuth)}
                  type={'password'}
                  valid={this.props.errors.password? false : undefined}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

}

export let defaultConnection: IAnalyticsExtConnectionSettings = {
  connection_luid: '',
  //connectionName: 'default',
  connection_type: 'SELECT',
  host: '',
  port: null,
  is_ssl_enabled: false,
  is_auth_enabled: false,
  username: '',
  password: ''
};

export const AnalyticsExtensionsSettingsForSite =
  withFormik < AnalyticsExtensionsSettingsCtrlProps, AnalyticsExtensionsSettingsForSiteValues>({
    enableReinitialize: true,   // Reset the form when initial props change
    validateOnBlur: true,
    mapPropsToValues: props => {
      let initInfoSite = false;
      let initInfoConnection =  defaultConnection;
      let connection = ConnectionTypes.SELECT;
      if (typeof props.initialAnalyticsExtensionsSettings !== 'undefined'){
        initInfoSite = props.initialAnalyticsExtensionsSettings.enableExtSvcSite;
      }
      if (props.initialAnalyticsExtensionsSettings?.connectionDefault){
        initInfoConnection = props.initialAnalyticsExtensionsSettings.connectionDefault;
      }
      if (initInfoConnection.connection_type ===  ConnectionTypes.TABPY.TAG){
        connection = ConnectionTypes.TABPY.DISPLAY;
      }
      if (initInfoConnection.connection_type === ConnectionTypes.RSERVE.TAG){
        connection = ConnectionTypes.RSERVE.DISPLAY;
      }

      return {
        showAnalyticsSiteSetting:props.displaySettings,
        showSiteCheckbox:props.displaySiteSettingCheckbox,
        enableExternalServicesCheckbox: initInfoSite,
        connectionLUID: initInfoConnection.connection_luid,
        connectionName: 'Default',
        connectionType: connection,
        hostName: initInfoConnection.host,
        port: initInfoConnection.port,
        isSecure: initInfoConnection.is_ssl_enabled,
        isAuth: initInfoConnection.is_auth_enabled,
        userName: initInfoConnection.username,
        password: initInfoConnection.password,
      };
    },
    validate: (values, props) => {
      const errors: any = {};
      let connectionTypeSelected = (values.connectionType) && (values.connectionType !== ConnectionTypes.SELECT);
      // If there wasn't a connection previously, and no connection created just now, there is no validation error
      if ((!connectionTypeSelected) && (!props.initialAnalyticsExtensionsSettings?.connectionDefault)) {
        return errors;
      } else {
        if ((!connectionTypeSelected) && (props.initialAnalyticsExtensionsSettings?.connectionDefault)) {
          errors.connectionType = 'Invalid';
        }
        if ((!values.hostName) || (values.hostName.length > MAX_HOSTNAME_LENGTH)) {
          errors.hostName = 'Invalid';
        }
        if ((!values.port) || (!Number.isInteger(+values.port)) || (+values.port < MIN_PORT_NUMBER) || (+values.port > MAX_PORT_NUMBER)) {
          errors.port = 'Invalid';
        }
        if (values.isAuth && values.userName && (values.userName.length > MAX_USERNAME_LENGTH)) {
          errors.userName = 'Invalid';
        }
        if (values.isAuth && values.password && (values.password.length > MAX_PASSWORD_LENGTH)) {
          errors.password = 'Invalid';
        }
      }
      return errors;
    },
    handleSubmit: (values, actions) => {
      // Reset the form after submission happens
      actions.setSubmitting(false);
      actions.resetForm({values});
    },
   })(InnerAnalyticsExtensionsSettingForSite);
